import React, { useState } from 'react'
import PropTypes from 'prop-types'
import AuthModal from 'components/modal/AuthModal'
import clsx from 'clsx'

import { Saved as SavedIcon } from 'components/listings/cards/Listings/components/SaveButton/Saved'
import s from './LikeButton.module.css'
import Collections from '../../../../collections/Collections/Collections'

function gtagReportConversion(url) {
  var callback = function () {
    if (typeof url != 'undefined') {
      window.location = url
    }
  }
  // eslint-disable-next-line no-undef
  gtag('event', 'likelisting', {
    send_to: 'AW-968054781/WSr4CPT3orwYEP2vzc0D',
    event_callback: callback,
  })
  return false
}

const LikeButton = (props) => {
  const { listing, loading: parentLoading, signedIn } = props

  const [showCollections, setShowCollections] = useState(false)

  const { id, status, meta } = listing

  if (status === 'Rented') {
    return null
  }

  const toggleLike = (e) => {
    e.preventDefault()

    if (signedIn === false) {
      return
    }

    gtagReportConversion()
    setShowCollections((state) => !state)
  }

  const isSaved = meta?.saved

  return (
    <>
      <div className={clsx(s.root, 'listing-like')} {...(signedIn && { onClick: toggleLike })}>
        <div className="button btn-transparent btn-block btn-rounded btn-search-bar-size" id={`listing_card_${id}`}>
          {signedIn || parentLoading ? (
            <SavedIcon className={isSaved ? s.saveIconSaved : s.saveIcon} />
          ) : (
            <AuthModal>
              <SavedIcon className={isSaved ? s.saveIconSaved : s.saveIcon} />
            </AuthModal>
          )}
        </div>
      </div>

      {showCollections && <Collections unitId={id} onClose={() => setShowCollections(false)} />}
    </>
  )
}

LikeButton.defaultProps = {
  loading: false,
}

LikeButton.propTypes = {
  loading: PropTypes.bool,
  listing: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    status: PropTypes.string,
    meta: PropTypes.shape({
      saved: PropTypes.bool,
    }),
    heartsCount: PropTypes.number,
  }).isRequired,
  signedIn: PropTypes.bool.isRequired,
}

export default LikeButton
